import { useDispatch } from "react-redux";

import { Product as ProductContent } from "./Product";
import MiniDrawer from "./components/drawer";

import Box from "@mui/material/Box";

import { setProductType } from "./productSlice";


//icons//
import BallotOutlinedIcon from "@mui/icons-material/BallotOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import DiscountIcon from '@mui/icons-material/Discount';
import BeenhereOutlinedIcon from "@mui/icons-material/BeenhereOutlined";
import BreakfastDiningOutlinedIcon from "@mui/icons-material/BreakfastDiningOutlined";
import BroadcastOnHomeOutlinedIcon from "@mui/icons-material/BroadcastOnHomeOutlined";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import CallToActionOutlinedIcon from "@mui/icons-material/CallToActionOutlined";
import CastleOutlinedIcon from "@mui/icons-material/CastleOutlined";
import BackpackIcon from '@mui/icons-material/Backpack';
import { useState } from "react";

const productTypes = [
  {
    id: 1,
    title: "Products",
    description: "Product management",
    icon: <BallotOutlinedIcon />,
    action: "action-1",
    disableSection: false,
    api_key: "products"
  },
  {
    id: 2,
    title: "Missions",
    description: "Taste mission management",
    icon: <BarChartOutlinedIcon />,
    action: "action-2",
    disableSection: false,
    api_key: "missions"
  },
  {
    id: 3,
    title: "Voucher Machine",
    description: "QR Code Voucher Management",
    icon: < DiscountIcon/>,
    action: "action-3",
    disableSection: false,
    api_key: "vouchersqr"
  },
  {
    id: 4,
    title: "Voucher SAP",
    description: "SAP Voucher Management",
    icon: <BeenhereOutlinedIcon />,
    action: "action-4",
    disableSection: false,
    api_key: "vouchersint"
  },
  {
    id: 5,
    title: "Voucher Ext",
    description: "External Voucher Management",
    icon: <BreakfastDiningOutlinedIcon />,
    action: "action-5",
    disableSection: false,
    api_key: "vouchersext"
  },
  {
    id: 6,
    title: "Promo Prefix",
    description: "Voucher - Product prefix association management",
    icon: <BroadcastOnHomeOutlinedIcon />,
    action: "action-6",
    disableSection: false,
    api_key: "promoPrefixes"
  },
  // {
  //   id: 7,
  //   title: "Collection",
  //   description: "Description 7",
  //   icon: <CachedOutlinedIcon />,
  //   action: "action-7",
  //   disableSection: true,
  //   api_key: "collections"
  // },
  // {
  //   id: 8,
  //   title: "Events",
  //   description: "Description 8",
  //   icon: <CallToActionOutlinedIcon />,
  //   action: "action-8",
  //   disableSection: true,
  //   api_key: "events"
  // },
  // {
  //   id: 9,
  //   title: "Product 9",
  //   description: "Description 9",
  //   icon: <CastleOutlinedIcon />,
  //   action: "action-9",
  //   disableSection: true,
  //   api_key: ""
  // },
  // {
  //   id: 10,
  //   title: "Product 10",
  //   description: "Description 10",
  //   icon: <BackpackIcon />,
  //   action: "action-10",
  //   disableSection: true,
  //   api_key: ""
  // },
  // {
  //   id: 11,
  //   title: "Product 11",
  //   description: "Description 11",
  //   icon: <BackpackIcon />,
  //   action: "action-11",
  //   disableSection: true,
  //   api_key: ""
  // },
];

export default productTypes;

const ProductWrapper = () => {
  const dispatch = useDispatch();
  const [selectedProduct, setSelectedProduct] = useState("Dashboard");

  const handleSetProductType = (productTitle) => {
    // console.log("Selected Product:", productTitle);
    setSelectedProduct(productTitle);
    dispatch(setProductType(productTitle.toLowerCase()));
  };

  // console.log("Selected Product in ProductWrapper:", selectedProduct);

  return (
    <Box position="relative" zIndex={10} component="main">
      <MiniDrawer
        firstItemKey={"Dashboard"}
        items={productTypes}
        handleChange={handleSetProductType}
        selectedProduct={selectedProduct}
      >
        <ProductContent />
      </MiniDrawer>
    </Box>
  );
};

export { ProductWrapper as Product };
